import React from 'react';

export default function CartographerHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,35.92 10.31,35.92 10.31,8.23 38.0,8.23" fill="#A27149" />
      <polygon points="10.31,35.92 38.0,35.92 29.69,31.77 2.0,31.77" fill="#5B3F29" opacity="0.95" />
      <polygon points="10.31,35.92 2.0,31.77 2.0,4.08 10.31,8.23" fill="#5B3F29" opacity="0.95" />
    </svg>
  );
}
